/**
 * Determines the current environment, based on the window hostname.
 *
 * @returns {String} Current environment. Either "prod", "qa", or "dev".
 */
const getCurrentEnv = () => {
  // eslint-disable-next-line no-console
  // Set in ENV
  if (process.env.REACT_APP_ENVIRONMENT) return process.env.REACT_APP_ENVIRONMENT;
  
  // Production
  if (
    window.location.hostname.includes('prod')
    || window.location.hostname === 'specialtyhub.lilly.com'
  ) {
    return 'prod';
  }
  
  // QA/Staging
  if (window.location.hostname.includes('qa')) {
    return 'qa';
  }
  
  // Development (default)
  return 'dev';
};

export default getCurrentEnv;
